
import React, { useState } from "react";
import { motion } from "framer-motion";
import screenshot from '../Images/Screenshot1.png'
import screensho from '../Images/Screenshot2.png'
import screensh from '../Images/Screenshot3.png'
import screens from '../Images/Screenshot4.png'
import screen from '../Images/Screenshot5.png'
import scree from '../Images/Screenshot6.png'



const Secone = () => {

    const [activeTab, setActiveTab] = useState("all");

    const projects = {
        all: [
        { img: screenshot, title: "THREE E.ENERGY LTD", subtitle: "Engineering Energy Efficiency", link: "https://3eenergyltd.com/" },
        { img: screensho, title: "Acheteur & Pixels", subtitle: "Creating cutting-edge solutions for advertisers and advertising firms", link: "https://acheteurpixels.com/" },
        { img: scree, title: "Go Fumigation", subtitle: "Providing prompt fumigation, guaranteed results for homes and offices", link: "https://gofumigation.com/" },
        { img: screensh, title: "AJ Fitness Pro", subtitle: "Specialized in strength training, weight loss, rehabilitation, and injury prevention.", link: "https://ajfitnesspro.com/" },
        { img: screen, title: "ARHCS HEALTH", subtitle: "Dedicated to revolutionizing healthcare delivery by providing innovative solutions and exceptional services tailored to meet the evolving needs of our clients", link: "https://arhcshealth.com/" },
        { img: screens, title: "Ampo Africa", subtitle: "Providing top-notch solutions to any Electrical Power problems and Render Top to bottom...", link: "https://ampoafrica.com/" },
        ],
        // web: [
        // { img: screens, title: "EcoStream", subtitle: "Web App" },
        // { img: screen, title: "EcoStream", subtitle: "Web App" },
        // { img: scree, title: "EcoStream", subtitle: "Web App" },
        // ],
        // mobile: [
        // { img: screenshot, title: "Nexus Bank", subtitle: "Mobile App" },
        // { img: screensho, title: "Nexus Bank", subtitle: "Mobile App" },
        // { img: screensh, title: "Nexus Bank", subtitle: "Mobile App" },
        // ],
        // enterprise: [
        // { img: screens, title: "LogiTrack", subtitle: "Enterprise Software" },
        // { img: screen, title: "LogiTrack", subtitle: "Enterprise Software" },
        // { img: scree, title: "LogiTrack", subtitle: "Enterprise Software" },
        // ],
        // uiux: [
        // { img: screenshot, title: "Nexus Bank", subtitle: "UI/UX Transformation" },
        // { img: screensho, title: "Nexus Bank", subtitle: "UI/UX Transformation" },
        // { img: screensh, title: "Nexus Bank", subtitle: "UI/UX Transformation" },
        // ],
    };
    
    const currentProjects = projects[activeTab] || [];
    const array = projects[activeTab] || [];

    const background ={
        background: '#353995',
        paddingBottom: '50px',
    }

    const glideUp = {
        initial: { opacity: 0, y: 60 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.7 },
        viewport: { once: true }
    };

    return(
        <>
        <div style={background}>
          <div className="container">
            <div className="row top text-center mb-4 gap-4">
                <div className="col-md-2 mt-4 p-3">
                <button
                    className={`proc ${activeTab === "all" ? "active" : ""}`}
                    onClick={() => setActiveTab("all")}
                >
                    All Projects
                </button>
                </div>
                {/* <div className="col-md-2 p-3">
                <button
                    className={`procs ${activeTab === "web" ? "active" : ""}`}
                    onClick={() => setActiveTab("web")}
                >
                    Web Development
                </button>
                </div>
                <div className="col-md-2 p-3">
                <button
                    className={`procs ${activeTab === "mobile" ? "active" : ""}`}
                    onClick={() => setActiveTab("mobile")}
                >
                    Mobile Apps
                </button>
                </div>
                <div className="col-md-2 p-3">
                <button
                    className={`procs ${activeTab === "enterprise" ? "active" : ""}`}
                    onClick={() => setActiveTab("enterprise")}
                >
                    Enterprise Software
                </button>
                </div>
                <div className="col-md-2 p-3">
                <button
                    className={`procs ${activeTab === "uiux" ? "active" : ""}`}
                    onClick={() => setActiveTab("uiux")}
                >
                    UI/UX Strategy
                </button>
                </div> */}
            </div>

            <div className="row g-4 mt-3">
            {currentProjects.map((project, index) => (
            <div className="col-md-4" key={index}>

                <motion.div
                className="project-card"
                {...glideUp}
                whileHover={{ 
                    y: -10,
                    scale: 1.03,
                    transition: { duration: 0.3 }
                }}
                >
            <a href={project.link} target="_blank" rel="noopener noreferrer">
            <img className="img-fluid" src={project.img} alt={project.title} />
            </a>

            <h4 className="mt-4">{project.title}</h4>
            <p>{project.subtitle}</p>

            </motion.div>

            </div>
            ))}
            </div>



            </div> 
        </div>
           



        </>
    )
}

export default Secone;